import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { snackbarUtils } from "../../utils";
import { useDeleteDevice } from "../../hooks/useDevices";
import { useNavigate } from "react-router-dom";

function DeviceDeleteDialog(props) {
  const { id, open, handleClose } = props;
  const navigate = useNavigate();
  const deleteDeviceMutation = useDeleteDevice();

  const handleDelete = async () => {
    deleteDeviceMutation.mutate(id, {
      onSuccess: () => {
        navigate("/device");
        handleClose();
      },
      onError: () => {
        snackbarUtils.updateMessage("Error deleting device");
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Device</DialogTitle>
      <DialogContent>
        <p>Are you sure you want to delete this device?</p>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => handleDelete()}
          color="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeviceDeleteDialog;
